// extracted by mini-css-extract-plugin
export default {"container":"Clickable_container__HuoID","center-content":"Clickable_center-content__lMBwC"};